export default __webpack_public_path__ + "static/media/samsung.71bb7028.jpg";